const notItems = [
  "You want someone to tell you what you want to hear",
  "You're looking for predictions, astrology, or motivational quotes",
  "You want a human therapist or counsellor",
];

const yesItems = [
  "You want a private place to think before you act",
  "You want clarity, not comfort — and one clear next step",
];

export default function NotForYouScene() {
  return (
    <section className="home-band px-5 sm:px-8">
      <div className="max-w-4xl mx-auto w-full text-left">
        <p className="scroll-reveal section-eyebrow">A clarification</p>

        <h2 className="scroll-reveal section-heading mt-3">
          This is{" "}
          <span className="italic" style={{ color: "hsl(var(--marigold))" }}>
            not
          </span>{" "}
          for you if…
        </h2>

        <div
          className="mt-10 sm:mt-14 border-t"
          style={{ borderColor: "hsl(var(--manuscript) / 0.08)" }}
        >
          {notItems.map((item) => (
            <div
              key={item}
              className="scroll-reveal grid grid-cols-[2.25rem_1fr] sm:grid-cols-[3rem_1fr] items-baseline gap-3 sm:gap-6 py-4 sm:py-5 border-b"
              style={{ borderColor: "hsl(var(--manuscript) / 0.08)" }}
            >
              <span
                className="font-display italic text-manuscript/30 tabular-nums"
                style={{ fontSize: "clamp(1rem, 1.4vw, 1.2rem)" }}
              >
                ✕
              </span>
              <p
                className="font-display text-manuscript/55 leading-snug"
                style={{ fontSize: "clamp(0.95rem, 1.5vw, 1.2rem)", letterSpacing: "-0.005em" }}
              >
                {item}
              </p>
            </div>
          ))}
        </div>

        <div className="scroll-reveal flex items-center gap-4 my-6 sm:my-8">
          <span className="flex-1 h-px" style={{ background: "hsl(var(--manuscript) / 0.12)" }} />
          <span className="font-display italic section-eyebrow">
            But
          </span>
          <span className="flex-1 h-px" style={{ background: "hsl(var(--manuscript) / 0.12)" }} />
        </div>

        <div>
          {yesItems.map((item) => (
            <div
              key={item}
              className="scroll-reveal grid grid-cols-[2.25rem_1fr] sm:grid-cols-[3rem_1fr] items-baseline gap-3 sm:gap-6 py-4 sm:py-5"
            >
              <span
                className="font-display tabular-nums"
                style={{
                  fontSize: "clamp(1rem, 1.4vw, 1.2rem)",
                  color: "hsl(var(--marigold))",
                }}
              >
                ✓
              </span>
              <p
                className="font-display text-manuscript leading-snug"
                style={{ fontSize: "clamp(1rem, 1.7vw, 1.35rem)", letterSpacing: "-0.01em" }}
              >
                {item}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
